
import { call, put } from 'redux-saga/effects';
import axios from 'axios';
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from '../../redux/modules/message/message-actions';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import {
    didApiCallFailDueToUnauthorizedUser,
    didApiCallFailDueToVersionMismatch,
    getErrorMessage,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import {
    clearCashPaymentVoucher,
    clearDebitAndCreditLines,
    FETCH_CASH_PAYMENT_VOUCHER_FAILURE,
    FETCH_CASH_PAYMENT_VOUCHER_SUCCESS,
    FETCH_DEBIT_AND_CREDIT_LINES_FAILURE,
    FETCH_DEBIT_AND_CREDIT_LINES_REQUEST,
    FETCH_DEBIT_AND_CREDIT_LINES_SUCCESS,
} from '../../redux/modules/cashPaymentVoucher/cashPaymentVoucher-actions';
import API from '../../constants/api';

export function* fetchDebitAndCreditLinesWorker(action) {
    try {
        const {
            api,
            accountId,
        } = action;
        const apiWithParams = `${api}?accountId=${accountId}`;
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(axios.get, apiWithParams);
        yield put({
            type: FETCH_DEBIT_AND_CREDIT_LINES_SUCCESS,
            data: {
                ...(response.data || {}),
            },
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            const msg = 'Debit and credit lines fetch failed';
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ type: FETCH_DEBIT_AND_CREDIT_LINES_FAILURE, data: {} });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export function* createOrUpdateCashPaymentVoucherWorker(action) {
    try {
        const {
            api,
            payload,
            successMessage,
        } = action;
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(axios.post, api, payload);
        yield put({
            type: FETCH_CASH_PAYMENT_VOUCHER_SUCCESS,
            data: {
                ...(response.data || {}),
            },
        });
        if (payload.state !== 'draft') {
            yield put(clearDebitAndCreditLines());
            yield put(clearCashPaymentVoucher());
        }

        yield put({
            type: FETCH_DEBIT_AND_CREDIT_LINES_REQUEST,
            api: API.CASH_PAYMENT_VOUCHER.GET_DEBIT_CREDIT_LINES_FOR_ACCOUNT,
            accountId: payload.partnerAccount.key,
        });

        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
        yield put({ type: SUCCESS_MESSAGE, message: successMessage });
    } catch (e) {
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            const msg = 'Create cash payment/receipt voucher failed';
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export function* fetchCashPaymentVoucherWorker(action) {
    try {
        const {
            api,
            voucherUuid,
        } = action;
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(axios.get, `${api}?voucherUuid=${voucherUuid}`);
        yield put({
            type: FETCH_CASH_PAYMENT_VOUCHER_SUCCESS,
            data: {
                ...(response.data || {}),
            },
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            const msg = 'Cash Payment/Receipt Voucher fetch failed';
            yield put({ type: ERROR_MESSAGE, message: `${msg}: ${getErrorMessage(e)}` });
        }
        yield put({ type: FETCH_CASH_PAYMENT_VOUCHER_FAILURE, data: {} });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}
